module.exports = {
  color_input: {
    choose_color_button: 'Select color',
  },
  edit_titles_text: {
    edit_icon: 'Rename',
  }
}
